/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2017 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/

import { LoadingSpinnerService } from "./components/loading-spinner/loading-spinner.service";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HttpTokenInterceptor } from "./services/interceptors/http-token-interceptor";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { LoadingSpinnerComponent } from "./components/loading-spinner/loading-spinner.component";
import { ValidateService } from "./utility/validate.service";
import { ServerErrorComponent } from "./components/server-error/server-error.component";
import { SsotokenService } from "./services/ssotoken/ssotoken.service";

@NgModule({
  declarations: [LoadingSpinnerComponent, ServerErrorComponent],
  imports: [CommonModule],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: HttpTokenInterceptor, multi: true },
    LoadingSpinnerService,
    ValidateService,
    SsotokenService,
  ],
  exports: [LoadingSpinnerComponent, ServerErrorComponent],
})
export class AppSharedModule {}
